import { Box, Text, Select, Textarea, Button, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { VerifyLoanRequest } from "../../services/axios";
import ModalLayout from "../Layout/ModalLayout";

const VerifyLoanModal = ({ id }) => {
  const toast = useToast();

  const [outcome, setOutcome] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const submitVerification = async () => {
    if (!(outcome && comment)) {
      return;
    }

    setLoading(true);
    try {
      const data = await VerifyLoanRequest(id, { outcome, comment });

      if (data) {
        toast({
          title: "Verification Submitted",
          description: data?.message,
          status: "success",
          position: "top-left",
          duration: 4000,
          isClosable: true,
        });

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      // handled by ErrorHandler
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ModalLayout
        title="Verify Loan Request"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        rejectHandler={submitVerification}
        loading={loading}
        successBtnText="SUBMIT"
      >
        <Box>
          <Text fontWeight="500" fontSize="14px" color="#33343D">
            Verification Outcome
          </Text>
          <Select
            mt="10px"
            className="form-input"
            placeholder="Select an outcome"
            onChange={(e) => setOutcome(e.currentTarget.value)}
          >
            <option value="approved">Verified</option>
            <option value="declined">Not Verified</option>
          </Select>

          <Text fontWeight="500" fontSize="14px" color="#33343D" mt="20px">
            Verification Comments / Feedback
          </Text>
          <Textarea
            height="36"
            value={comment}
            my="10px"
            onChange={(e) => setComment(e.currentTarget.value)}
            className="form-input"
            placeholder="Business, address and KYC verification notes"
          />
        </Box>
      </ModalLayout>

      <Button
        onClick={() => setIsOpen(true)}
        bg="#5B2E4F"
        borderRadius="6px"
        fontSize={["9px", "12px"]}
        fontWeight="500"
        color="white"
        p={["8px 22px", "5px 37px"]}
        _hover={{ color: "#5B2E4F", border: "1px solid #5B2E4F", bg: "white" }}
      >
        {loading ? "PROCESSING..." : "VERIFY"}
      </Button>
    </>
  );
};

export default VerifyLoanModal;
